
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_13992_23910)"}},[_c('path',{attrs:{"d":"M.033 14l.984-3.595a6.922 6.922 0 01-.925-3.469C.093 3.112 3.205 0 7.029 0c1.856 0 3.598.723 4.908 2.035a6.898 6.898 0 012.03 4.908c-.002 3.825-3.114 6.937-6.938 6.937a6.942 6.942 0 01-3.318-.845L.033 14zm3.849-2.22c.977.58 1.91.927 3.145.928a5.777 5.777 0 005.768-5.766 5.764 5.764 0 00-5.763-5.77 5.775 5.775 0 00-5.77 5.765c0 1.298.38 2.27 1.02 3.286l-.583 2.128 2.183-.572zm6.642-3.188c-.043-.072-.159-.116-.333-.203-.173-.086-1.025-.506-1.184-.564-.159-.057-.274-.087-.39.087a10.18 10.18 0 01-.55.68c-.1.115-.202.13-.375.043-.173-.087-.732-.27-1.394-.86a5.218 5.218 0 01-.965-1.201c-.1-.174-.01-.268.076-.354.078-.077.174-.202.26-.304.089-.1.117-.173.175-.289.058-.115.03-.217-.014-.303-.044-.087-.39-.94-.534-1.287-.142-.338-.285-.293-.39-.298l-.333-.006a.635.635 0 00-.462.217c-.159.174-.607.593-.607 1.446 0 .854.621 1.678.708 1.794.087.115 1.222 1.866 2.96 2.617.414.178.737.285.989.365.415.132.793.113 1.092.069.333-.05 1.025-.42 1.17-.824.145-.406.145-.753.1-.825z","fill":"#27D045"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_13992_23910"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    